import React from "react";
import { withStyles, Grid, Button } from "@material-ui/core";

const styles = (theme) => ({
    outlined:{
        justifyContent: "flex-start",
        display: "flex",
        height: 26,
        fontWeight: 500,
        fontSize: theme.textFontSize,
        lineHeight: "14px",
        letterSpacing: "0.25px",
        borderLeft: 0,
        borderRight: 0,
        borderRadius:0,
        paddingLeft: 20,
        borderColor:theme.gridGroupHeaderBorderColor,
    }
})

const AddTrailer = (props) => {
  return (
    <Grid item xs={12} >
      <Button
        variant="outlined"
        color="primary"
        onClick={props.onClick}
        id="addTrailerButton"
        fullWidth
        size="small"
        classes={{
          outlined: props.classes.outlined,
        }}
      >
        + ADD TRAILER
      </Button>
    </Grid>
  );
};

export default withStyles(styles)(AddTrailer)